import { WBFullScreenModal } from '@admiin-com/ds-web';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { Image } from '@admiin-com/ds-common';
import { CsvMapFields } from '../CSVMapFields/CsvMapFields';
import { CsvUpload } from '../CsvUpload/CsvUpload';
import PageSelector from '../../components/PageSelector/PageSelector';
import { useSearchParams } from 'react-router-dom';
import { CsvClientMapFields } from '../CSVClientMapFields/CsvClientMapFields';
export interface BulkImportModalProps {
  open: boolean;
  handleCloseModal: () => void;
  type?: 'contacts' | 'clients';
}

export type PageType = 'Upload' | 'Map';

export function BulkImport({
  open,
  handleCloseModal: onClose,
  type = 'contacts',
}: BulkImportModalProps) {
  const { t } = useTranslation();

  const [csvFile, setCSVFile] = React.useState<File>();
  const [page, setPage] = React.useState<PageType>('Upload');
  const [uploadMedia, setUploadedMedia] = React.useState<Image | null>(null);

  const handleSubmitted = () => {
    setTimeout(() => {
      handleCloseModal();
      setPage('Map');
    }, 7000);
  };

  const [, setSearchParams] = useSearchParams();

  const handleCloseModal = () => {
    onClose();
    setSearchParams({ contactImport: '' });
  };

  if (!open) {
    return null;
  }

  return (
    <WBFullScreenModal
      leftToolbarIconProps={{
        onClick: () =>
          page === 'Map' ? setPage('Upload') : handleCloseModal(),
      }}
      leftToolbarIconTitle={
        page === 'Upload'
          ? t(type === 'clients' ? 'bulkImportClients' : 'bulkImportContacts', {
              ns: 'contacts',
            })
          : t(type === 'clients' ? 'clients' : 'contacts', { ns: 'contacts' })
      }
      onClose={handleCloseModal}
      title={
        page === 'Upload'
          ? t('mapCSVfields', { ns: 'contacts' })
          : t(type === 'clients' ? 'bulkImportClients' : 'bulkImportContacts', {
              ns: 'contacts',
            })
      }
      open={open}
    >
      <PageSelector current={page}>
        <PageSelector.Page value={'Map'}>
          {type === 'contacts' && (
            <CsvMapFields
              file={csvFile}
              fileKey={uploadMedia?.key ?? ''}
              onSubmitted={handleSubmitted}
            />
          )}
          {type === 'clients' && (
            <CsvClientMapFields
              file={csvFile}
              fileKey={uploadMedia?.key ?? ''}
              onSubmitted={handleSubmitted}
            />
          )}
        </PageSelector.Page>
        <PageSelector.Page value={'Upload'}>
          <CsvUpload
            type={type}
            onUploaded={(media, file) => {
              setPage('Map');
              setCSVFile(file);
              setUploadedMedia(media);
            }}
          />
        </PageSelector.Page>
      </PageSelector>
    </WBFullScreenModal>
  );
}
